var map = {
	"./de.json": "6ce2",
	"./dk.json": "bb2e",
	"./en.json": "edd4",
	"./es.json": "a306",
	"./fi.json": "5754",
	"./fr.json": "f693",
	"./it.json": "0825",
	"./nl.json": "a625",
	"./no.json": "f947",
	"./pl.json": "89b2",
	"./pt.json": "5d67",
	"./sv.json": "4c5b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";